import { css } from '@/styled-system/css';

export const modalHeaderStyles = css.raw({
  'flexGrow': 0,
  'flexShrink': 0,
  'flexBasis': 'auto',
  'paddingBlock': 'Modal.Header.padding.vert',
  'paddingInlineStart': 'Modal.Header.padding.left',
  'paddingInlineEnd': 'Modal.Header.padding.right',

  '& > [data-c11n-component="Heading"]': {
    color: 'Modal.Header.text',
    textStyle: 'heading-xs',
  },
});
